import {Helmet} from '@dr.pogodin/react-helmet';
import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {DocumentRoundingDefinitionForm} from './components/DocumentRoundingDefinitionForm';

export function DocumentRoundingDefinitionsNew() {
  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.accounting.labels.documentRoundingDefinitions'),
      href: settingsRoutes.documentRoundingDefinitions,
    },
  ];

  const title = i18n.t('page.accounting.labels.documentRoundingDefinitions');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{title, breadcrumbs}}
        data-testid="settings-document-rounding-definition-add-page"
      >
        <DocumentRoundingDefinitionForm />
      </SettingsTemplate>
    </>
  );
}
